<template>
<div id="bgm" class="bgm">
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container"  @submit.native.prevent>
    <h3 class="title">系统登录</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"  @keyup.enter.native="handleSubmit" placeholder="密码"></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit" :loading="logining">登录</el-button>
      <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
    </el-form-item>
  </el-form>
</div>



</template>

<script>
  import { requestLogin } from '../api/api';
  import {usermodel} from '../model/models';
  //状态管理器
  import {mapState, mapMutations,mapGetters, mapActions} from 'vuex';
  // import longonbgm from "../assets/longonbgm.jpg";

  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        // backgroundImage:longonbgm,
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          checkPass: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },
        checked: true
      };
    },
    methods: {
      ...mapMutations(['ADD_LOGIN_USER']),
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
      handleSubmit(ev) {
        var _this = this;
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            //_this.$router.replace('/table');
            this.logining = true;
            //NProgress.start();
            // var loginParams = { username: this.ruleForm2.account, password: this.ruleForm2.checkPass };
       
            	let loginParams = {
					Number: this.ruleForm2.account,
          Password: this.ruleForm2.checkPass,
          ValidateCode:'1234'
        };
            //  console.log(loginParams);
            requestLogin(loginParams).then(data => {
              //测试输出
              // console.log(data);
              this.logining = false;
              //NProgress.done();
              let { Msg, ErrorCode, Data,ExtendData,Success } = data;
              // console.log(ErrorCode+'  '+Success);
              if (Success==false) {
                this.$message({
                  message: Msg,
                  type: 'error'
                });
              } else {
                // console.log(data);
                usermodel.CreationTime=Data.CreationTime;
                  usermodel.Id=Data.Id;
                  usermodel.Name=Data.Name;
                  usermodel.Number=Data.Number;
                  usermodel.Remark=Data.Remark;
                  usermodel.State=Data.State;
                  usermodel.StateName=Data.StateName;
                  usermodel.TenancyId=Data.TenancyId;
                  usermodel.DreamToken=ExtendData;
                  usermodel.UserLevel=Data.UserLevel;
                  usermodel.CompetitionId='';
                  usermodel.SkinVersion=Data.SkinVersion;
                  console.log(usermodel.SkinVersion);
                  // usermodel.ShopId=data.ShopId;
                  // console.log(JSON.stringify(usermodel));
                sessionStorage.setItem('user', JSON.stringify(usermodel));
                 sessionStorage.setItem('routerState', false);
                //设置vuex用户状态
                // console.log(JSON.stringify(user));
                  

                 this.ADD_LOGIN_USER(JSON.stringify(usermodel));
                //  window.location.reload()
                if(usermodel.TenancyId=='0'||usermodel.TenancyId==null)
                {
             
                   
                this.$router.push({ path:'/' });

                }
                else
                {
          

                this.$router.push({ path:'/' });

                }
              }
            });
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
.bgm{
background-image: url("../assets/longonbgm.jpg");
width:100%;height:100%;
overflow: hidden;
}
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    // background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// Login.vue?b6591542